<div class="carousel">
    <div class="imgs_slides">
        <input *ngFor="let item of panels; let i = index;" type="radio" name="radio-btn" id="radio-{{i}}" />
        <ng-template ngFor let-panel [ngForOf]="panels" let-i="index">
            <div class="slide flex-container align-center" [ngClass]="{'first':i == 0}">
                <ng-container *ngTemplateOutlet="panel"></ng-container>
            </div>
        </ng-template>
    </div>
    <div class="navigation">
        <label *ngFor="let item of panels; let i = index;" for="radio-{{i}}" class="navigation-btn">
        </label>
    </div>
</div>

